<div class="bmc-working-time-schema-days">

  <div class="bmc-working-time-schema-days__header">
    <bzg-button-icon (click)="addWorkingTimeSchema()" class="bmc-working-time-schema-days__header-add" icon="icon-plus"></bzg-button-icon>
    <div class="bmc-working-time-schema-days__header-title" *ngIf="!isWorking">{{"WORKING_TIME_SCHEMA.ADDITIONAL_NON_WORKING_DAYS_DESCRIPTION" | translate}}</div>
    <div class="bmc-working-time-schema-days__header-title" *ngIf="isWorking">{{"WORKING_TIME_SCHEMA.CUSTOM_WORKING_HOURS_DESCRIPTION" | translate}}</div>
  </div>

  <div class="bmc-working-time-schema-days__table" *ngIf="(!isWorking && nonWorkingTimeSchemaUser.length > 0)">
    <div class="bmc-working-time-schema-days__table-header" [ngStyle]="{'grid-template-columns': 'repeat(' + columnCount + ', 1fr)'}">
      <div class="bmc-working-time-schema-days__table-header-title">{{ 'WORKING_TIME_SCHEMA.COLUMN_START_DATE' | translate}}</div>
      <div class="bmc-working-time-schema-days__table-header-title">{{ 'WORKING_TIME_SCHEMA.COLUMN_FINISH_DATE' | translate}}</div>
      <div class="bmc-working-time-schema-days__table-header-title">{{ 'WORKING_TIME_SCHEMA.COLUMN_DAYS' | translate}}</div>
      <div class="bmc-working-time-schema-days__table-header-title">{{ 'WORKING_TIME_SCHEMA.COLUMN_EDIT' | translate}}</div>
      <div class="bmc-working-time-schema-days__table-header-title">{{ 'WORKING_TIME_SCHEMA.COLUMN_DELETE' | translate}}</div>
    </div>

    <div class="bmc-working-time-schema-days__table-body" [ngStyle]="{'grid-template-columns': 'repeat(' + columnCount + ', 1fr)'}" 
      *ngFor="let workingTimeSchema of nonWorkingTimeSchemaUser">
      <div>{{workingTimeSchema.fromDate | date:'MM/dd/yyyy'}}</div>
        <div>{{workingTimeSchema.toDate | date:'MM/dd/yyyy'}}</div>
        <div>{{workingTimeSchema.days}}</div>
        <bzg-button-icon [icon]="'icon-edit'" (click)="editWorkingTimeSchema(workingTimeSchema)"></bzg-button-icon>
        <bzg-button-icon [icon]="'icon-delete'" (click)="deleteWorkingTimeSchema(workingTimeSchema)"></bzg-button-icon>
    </div>
    
  </div>

  <div class="bmc-working-time-schema-days__table" *ngIf="(isWorking && workingTimeSchemaUser.length > 0)">
    <div class="bmc-working-time-schema-days__table-header" [ngStyle]="{'grid-template-columns': 'repeat(' + columnCount + ', 1fr)'}">
      <div class="bmc-working-time-schema-days__table-header-title">{{ 'WORKING_TIME_SCHEMA.COLUMN_START_DATE' | translate}}</div>
      <div class="bmc-working-time-schema-days__table-header-title">{{ 'WORKING_TIME_SCHEMA.COLUMN_FINISH_DATE' | translate}}</div>
      <div class="bmc-working-time-schema-days__table-header-title">{{ 'WORKING_TIME_SCHEMA.COLUMN_DAYS' | translate}}</div>
      <div class="bmc-working-time-schema-days__table-header-title">{{ 'WORKING_TIME_SCHEMA.TIME_DETAILS' | translate}}</div>
      <div class="bmc-working-time-schema-days__table-header-title">{{ 'WORKING_TIME_SCHEMA.COLUMN_EDIT' | translate}}</div>
      <div class="bmc-working-time-schema-days__table-header-title">{{ 'WORKING_TIME_SCHEMA.COLUMN_DELETE' | translate}}</div>
    </div>

    <div class="bmc-working-time-schema-days__table-body" [ngStyle]="{'grid-template-columns': 'repeat(' + columnCount + ', 1fr)'}" 
      *ngFor="let workingTimeSchema of workingTimeSchemaUser">
      <div>{{workingTimeSchema.fromDate | date:'MM/dd/yyyy'}}</div>
        <div>{{workingTimeSchema.toDate | date:'MM/dd/yyyy'}}</div>
        <div>{{workingTimeSchema.days}}</div>
        <bzg-button-icon [icon]="'icon-timer'" (click)="openTimeDetails(workingTimeSchema)"
          [bzgMenuTrigger]="timeDetails" [bzgMenuYPosition]="'below'" [bzgMenuXPosition]="'before'">
        </bzg-button-icon>
        <bzg-button-icon [icon]="'icon-edit'" (click)="editWorkingTimeSchema(workingTimeSchema)" ></bzg-button-icon>
        <bzg-button-icon [icon]="'icon-delete'" (click)="deleteWorkingTimeSchema(workingTimeSchema)"></bzg-button-icon>
    </div>
    
  </div>

  <div class="bmc-working-time-schema-days__without-results" *ngIf="(!isWorking && nonWorkingTimeSchemaUser.length === 0) || (isWorking && workingTimeSchemaUser.length === 0)">
    <span>{{ 'WORKING_TIME_SCHEMA.NO_RESULTS' | translate}}</span>
  </div>
</div>


<bzg-menu #timeDetails>
  <bzg-menu-item class="menu__header">
    <div class="menu__header-title">{{ 'WORKING_TIME_SCHEMA.TIME_DETAILS' | translate }}</div>
  </bzg-menu-item>
  <bzg-menu-item class="menu__table-row">
    <div class="menu__table-row-title">{{ 'GLOBAL.FROM' | translate}}</div>
    <div class="menu__table-row-title">{{ 'GLOBAL.TO' | translate}}</div>
  </bzg-menu-item>
  <bzg-menu-item *ngIf="seletedWorkingTimeSchema && seletedWorkingTimeSchema.fromTime1 && seletedWorkingTimeSchema.toTime1" class="menu__table-row">
    <div class="menu__table-row-date">{{seletedWorkingTimeSchema.fromTime1 | showDateFormat: 7}}</div>
    <div class="menu__table-row-date">{{seletedWorkingTimeSchema.toTime1 | showDateFormat: 7}}</div>
  </bzg-menu-item>
  <bzg-menu-item *ngIf="seletedWorkingTimeSchema && seletedWorkingTimeSchema.fromTime2 && seletedWorkingTimeSchema.toTime2" class="menu__table-row">
    <div class="menu__table-row-date">{{seletedWorkingTimeSchema.fromTime2 | showDateFormat: 7}}</div>
    <div class="menu__table-row-date">{{seletedWorkingTimeSchema.toTime2 | showDateFormat: 7}}</div>
  </bzg-menu-item>
  <bzg-menu-item  *ngIf="seletedWorkingTimeSchema && seletedWorkingTimeSchema.fromTime3 && seletedWorkingTimeSchema.toTime3" class="menu__table-row">
    <div class="menu__table-row-date">{{seletedWorkingTimeSchema.fromTime3 | showDateFormat: 7}}</div>
    <div class="menu__table-row-date">{{seletedWorkingTimeSchema.toTime3 | showDateFormat: 7}}</div>
  </bzg-menu-item>
  <bzg-menu-item *ngIf="seletedWorkingTimeSchema && seletedWorkingTimeSchema.fromTime4 && seletedWorkingTimeSchema.toTime4" class="menu__table-row">
    <div class="menu__table-row-date">{{seletedWorkingTimeSchema.fromTime4 | showDateFormat: 7}}</div>
    <div class="menu__table-row-date">{{seletedWorkingTimeSchema.toTime4 | showDateFormat: 7}}</div>
  </bzg-menu-item>
  <bzg-menu-item *ngIf="seletedWorkingTimeSchema && seletedWorkingTimeSchema.fromTime5 && seletedWorkingTimeSchema.toTime5" class="menu__table-row">
    <div class="menu__table-row-date">{{seletedWorkingTimeSchema.fromTime5 | showDateFormat: 7}}</div>
    <div class="menu__table-row-date">{{seletedWorkingTimeSchema.toTime5 | showDateFormat: 7}}</div>
  </bzg-menu-item>
</bzg-menu>
